import React from 'react';
import styles from './premium-bottomsheet.module.scss';
import { LikedPayedProfile, Profile } from '@/types/profile';
import { Avatar, BottomSheet, Button, Typography } from '@/ui-kit';
import { routesApp } from '@/constans/routes';
import clsx from 'clsx';
import { MagicIcon, PremiumIcon } from '@/assets/icons';
import { BadgePremium } from '../badge-premium';
import { useNavigate } from 'react-router-dom';
import badgePriority from '@/assets/images/subscription/badge-priority.svg';
import { useAuth } from '@/store/useAuth';

interface Props {
    photo?: string | null;
    name?: string | null;
    isPremiumModalOpen: boolean;
    setIsPremiumModalOpen: (val: boolean) => void;
}

export const PremiumBottomsheet: React.FC<Props> = ({
    photo,
    name,
    isPremiumModalOpen,
    setIsPremiumModalOpen,
}) => {
    const navigate = useNavigate();

    const userData =
        useAuth((state) => state.getUser());
    
    return (
        <BottomSheet
            overlayClassName={styles.bottomsheetOverlay}
            isOpen={isPremiumModalOpen}
            isDeskorTop={false}
            onClose={() => setIsPremiumModalOpen(false)}>
            <div className={styles.premiumModalContent}>
                {
                    photo &&
                    <div className={styles.premiumModalContentIcon}>
                        <Avatar
                            src={photo}
                            size={96} />
                        <PremiumIcon
                            className={styles.premiumModalContentIconPremium}
                            width={28}
                            height={28} />
                    </div>
                }
                {
                    name &&
                    <div className={styles.premiumModalContentHeader}>
                        <Typography
                            className={styles.premiumModalContentHeaderTitle}
                            variant={'h5'}
                            fontWeight={'bold'}>
                            {name} с Premium
                        </Typography>
                        <Typography
                            className={styles.premiumModalContentHeaderDesc}>
                            Пользуется всеми возможностями приложения
                        </Typography>
                    </div>
                }
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 16,
                }}>
                    <BadgePremium
                        className={styles.premiumBottomsheetBadge}
                        description="Смотрите анкеты тех, кому вы понравились&nbsp;и&nbsp;отвечайте взаимностью" />
                    <BadgePremium
                        className={styles.premiumBottomsheetBadge}
                        icon={badgePriority}
                        title="Повышенный приоритет"
                        description="Вашу анкету увидет больше пользователей" />
                </div>
                {
                    userData?.is_paid ?
                        <Button
                            typeColor="orange"
                            className={styles.premiumModalContentFootnoteBtn}
                            onClick={() => setIsPremiumModalOpen(false)}>
                            Понятно!
                        </Button>
                    :
                        <Button
                            className={clsx(
                                styles.premiumModalContentFootnoteBtn,
                                styles.premiumModalContentFootnoteActivateBtn
                            )}
                            onClick={() => {
                                setIsPremiumModalOpen(false)
                                navigate(routesApp.subscription)
                            }}>
                            <Typography
                                variant="h5"
                                fontWeight="semibold"
                                className={styles.premiumModalContentFootnoteActivateBtnLabel}>
                                Активировать Premium
                            </Typography>
                            <MagicIcon />
                        </Button>
                }
            </div>
        </BottomSheet>
    );
};
